import NRReactGrid from '../../../NRReactGrid/NRReactGrid';
import { DateProvider } from '../DateProvider';
import { OverallRiskProvider } from '../OverallRiskProvider/OverallRiskProvider';
import { FilePathProvider } from '../FilePathProvider';
import { CorrelationsGridNameLinkProvider } from '../NameLinkProvider/CorrelationsGridNameLinkProvider';

const correlationsColumnsExtensions = [
  {
    columnName: 'risk',
    align: 'center',
    width: 160
  }
];

const correlationsColumns = [
  {
    title: { value: 'Report' },
    name: 'assetName'
  }
  // TO BE ADDED WHEN BE IS READY
  // {
  //   title: { value: 'Artifact' },
  //   name: 'artifact'
  // },
  // {
  //   title: { value: 'Location' },
  //   name: 'fileName'
  // },
  // {
  //   title: { value: 'Last modified' },
  //   name: 'updatedAt',
  //   dateFormat: CONSTANTS.DATE_FORMAT.HEADER,
  //   sortDisabled: true
  // },
  // {
  //   title: { value: 'Risk' },
  //   name: 'risk',
  //   hideColumn: false,
  //   sortDisabled: true,
  //   hideFilter: true,
  //   disableEdit: true,
  //   getCellValue: row => (typeof row?.risk?.score === 'number' ? row?.risk?.score : undefined)
  // }
];

function CorrelationsGrid({ setOpen, rows }) {
  return (
    <NRReactGrid
      pageSize={10}
      variant="elevation"
      elevation={0}
      rows={rows}
      columns={correlationsColumns}
      columnExtensions={correlationsColumnsExtensions}
      embedded
      providersArray={[
        <CorrelationsGridNameLinkProvider extraParams={{ closeModal: () => setOpen(false) }} key="nameLinkProvider" for={['assetName']} />,
        <DateProvider key="dateProvider" for={['updatedAt']} />,
        <OverallRiskProvider key="overallRiskProvider" for={['risk']} />,
        <FilePathProvider key="FilepathProvider" for={['fileName']} />
      ]}
      showIntegratedSelection={false}
      showSelectAll={false}
      statesArray={[]}
      renderersArray={[]}
      addDefaultSorting={false}
    />
  );
}
export default CorrelationsGrid;
